import { useEffect, useState } from "react";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import { ResponsiveContainer, ComposedChart, Line, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from "recharts";
import { api } from "@/lib/api";

const Delta = ({ v, unit = "" }) => {
  if (v == null) return <span className="text-muted-foreground">—</span>;
  const C = v > 0 ? TrendingUp : v < 0 ? TrendingDown : Minus;
  return <span className={`inline-flex items-center gap-1 font-mono ${v > 0 ? "text-rose-500" : v < 0 ? "text-emerald-500" : "text-muted-foreground"}`}><C size={13} />{v > 0 ? "+" : ""}{v}{unit}</span>;
};

export function OrgExposureTrend({ did, refreshKey }) {
  const [t, setT] = useState(null);
  useEffect(() => { api.get(`/org/domains/${did}/trend`).then((r) => setT(r.data)); }, [did, refreshKey]);
  if (!t) return null;
  const w = t.weeks;
  const last = w[w.length - 1];
  return (
    <div className="panel p-4 space-y-3" data-testid="org-exposure-trend">
      <div className="flex flex-wrap items-center gap-4"><div className="eyebrow">Tendance d'exposition — semaine après semaine</div>
        {last && <div className="ml-auto flex gap-4 text-xs" data-testid="org-trend-delta">
          <span>Taux : <b className="font-mono">{last.exposure_rate} %</b> <Delta v={last.delta_rate} unit=" pt" /></span>
          <span>Exposées : <b className="font-mono">{last.exposed}</b> <Delta v={last.delta_exposed} /></span></div>}</div>
      {w.length < 2 ? <div className="text-xs text-muted-foreground" data-testid="org-trend-empty">{w.length ? "Une seule semaine de mesure : la courbe apparaîtra après le prochain contrôle d'une semaine ultérieure (activez le re-contrôle hebdomadaire)." : "Aucune mesure : lancez un premier contrôle."}</div> : (
        <div className="h-56" data-testid="org-trend-chart"><ResponsiveContainer width="100%" height="100%" initialDimension={{ width: 600, height: 224 }}>
          <ComposedChart data={w} margin={{ top: 5, right: 10, left: -10, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
            <XAxis dataKey="week" tick={{ fontSize: 10 }} /><YAxis yAxisId="r" unit="%" tick={{ fontSize: 10 }} domain={[0, 100]} /><YAxis yAxisId="n" orientation="right" tick={{ fontSize: 10 }} allowDecimals={false} />
            <Tooltip contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", fontSize: 12 }} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Bar yAxisId="n" dataKey="exposed" name="Adresses exposées" fill="#D4AF37" opacity={0.5} />
            <Bar yAxisId="n" dataKey="password_exposed" name="Mots de passe exposés" fill="#EF4444" opacity={0.5} />
            <Line yAxisId="r" type="monotone" dataKey="exposure_rate" name="Taux d'exposition (%)" stroke="#06B6D4" strokeWidth={2} dot />
          </ComposedChart></ResponsiveContainer></div>)}
      <div className="text-[10px] text-muted-foreground">Dernière mesure de chaque semaine ISO · {t.snapshots} contrôle(s) enregistré(s)</div>
    </div>
  );
}
